import { useMainStore } from '@/stores/mainStore';

export const AUTO_CODE_MULTI_PARCOURS = 'MULTI PARCOURS';

/**
 * Réduction automatique dès la 2e inscription (même nom, prénom, date de naissance).
 */
class SecondRegistrationDiscountService {
    deleteMultiParcoursCode(bookingStore) {
        for (let i = 0; i < bookingStore.inscriptions.length; i++) {
            const code = bookingStore.inscriptions[i].code_reduction;
            if (code && code.nom == AUTO_CODE_MULTI_PARCOURS) {
                bookingStore.inscriptions[i].code_reduction = null;
                bookingStore.inscriptions[i].update_cart('code_reduction');
                bookingStore.inscriptions[i].compute_cart();
            }
        }
    }

    handleMultiParcours(bookingStore) {
        const mainStore = useMainStore();
        const percent = parseFloat(mainStore.module.reduction_deuxieme_inscription);
        if (!percent || percent <= 0) return;

        this.deleteMultiParcoursCode(bookingStore);

        for (let i = 0; i < bookingStore.inscriptions.length; i++) {
            const inscription = bookingStore.inscriptions[i];
            if (inscription.get_prix_course() <= 0 || inscription.code_reduction) continue;
            if (!inscription.coureur?.is_deuxieme_inscription_ou_plus?.(inscription)) continue;
            inscription.apply_multi_parcours_discount(percent);
        }
    }
}

export default new SecondRegistrationDiscountService();
